export default {
	welcome: "Bienvenue sur ORI",
	subtitle: "Système de gestion pour les temples d'Umbanda",
	description: "Une plateforme complète pour gérer la vie spirituelle de votre temple, du suivi du parcours médiumnique à l'organisation des rituels et des chaînes spirituelles.",
	trust: {
		secure: "Sécurisé et fiable",
		secureDesc: "Données protégées par chiffrement",
		respectful: "Respectueux",
		respectfulDesc: "Développé avec soin et respect des traditions",
		intuitive: "Intuitif",
		intuitiveDesc: "Interface simple et facile à utiliser",
	},
	tagline: "Créé d'un enfant de l'Axé pour un autre enfant de l'Axé",
	howItWorks: {
		title: "Comment ça fonctionne",
		subtitle: "En trois étapes simples, votre temple sera organisé",
		step1: {
			title: "Enregistrez votre temple",
			description: "Créez votre compte, configurez le nom de votre temple et invitez des utilisateurs",
		},
		step2: {
			title: "Configurez votre maison",
			description: "Ajoutez des médiums, leurs guides, les types de consultation et les rituels",
		},
		step3: {
			title: "Gérez en toute simplicité",
			description: "Contrôlez les rituels, les consultations, les finances et suivez le parcours médiumnique",
		},
	},
	faq: {
		title: "Questions fréquentes",
		q1: "ORI propose-t-il des forfaits payants ?",
		a1: "Nous proposerons bientôt des forfaits avec des fonctionnalités avancées. Restez informé des mises à jour sur notre site.",
		q2: "Mes données sont-elles en sécurité ?",
		a2: "Absolument. Nous utilisons le chiffrement, l'isolation par temple (RLS) et des sauvegardes automatiques. Aucun temple ne peut accéder aux données d'un autre.",
		q3: "Fonctionne-t-il sur mobile ?",
		a3: "Nous travaillons sur la compatibilité mobile. Sur les tablettes, le système fonctionne parfaitement.",
		q4: "Puis-je appeler les fiches sur une télévision ?",
		a4: "Oui, ORI dispose d'une application Android pour Google TV ou Fire TV où vous pouvez appeler les fiches depuis une tablette ou un téléphone, en plus d'afficher des messages personnalisés et des vidéos pour les consultants.",
		q5: "Puis-je utiliser mes fiches physiques ? Ou imprime-t-il des fiches ?",
		a5: "Vous pouvez utiliser vos fiches physiques, ou utiliser l'option d'impression via une imprimante thermique. Le coût par fiche imprimée est inférieur à 1 centime. De plus, la fiche contient plus d'informations et peut inclure des messages personnalisés pour chaque consultant.",
		q6: "Puis-je l'utiliser dans plus d'un temple ?",
		a6: "Oui. Un seul compte peut être lié à plusieurs temples avec des rôles différents. Chaque temple dispose de son propre plan et abonnement indépendant.",
		q7: "ORI s'intègre-t-il à une banque pour recevoir des paiements ?",
		a7: "Oui ! Via Mercado Pago, vous connectez le compte de votre temple et encaissez les cotisations et contributions par PIX ou carte de crédit — avec lien de paiement, rapprochement automatique et prélèvement automatique récurrent. Les frais sont ceux de Mercado Pago : PIX 0,99 % par transaction (versement immédiat) et carte de crédit environ 4,98 % (baissant à ~3,98 % après 30 jours), y compris pour les paiements récurrents. ORI ne prend rien de plus — l'argent arrive directement sur le compte du temple.",
	},
	manual: {
		link: "Manuel",
	},
	nav: {
		screens: "Écrans",
		faq: "FAQ",
		contact: "Contact",
		plans: "Forfaits",
	},
	contact: {
		title: "Contactez-nous",
		subtitle: "Vous avez une question ou une suggestion ? Envoyez-nous un message !",
		name: "Nom",
		subject: "Objet",
		message: "Message",
		email: "E-mail",
		phone: "Téléphone",
		referralSource: "Comment avez-vous entendu parler d'ORI ?",
		send: "Envoyer le message",
		success: "Message envoyé avec succès ! Nous vous répondrons bientôt.",
		errors: {
			message: "Le message est obligatoire",
			email: "L'e-mail est obligatoire",
			generic: "Erreur lors de l'envoi du message. Veuillez réessayer.",
		},
		referrals: {
			google: "Google / Recherche internet",
			socialMedia: "Réseaux sociaux",
			friend: "Recommandation d'un ami",
			event: "Événement / Conférence",
			other: "Autre",
		},
	},
	cta: {
		login: "Se connecter",
		dashboard: "Aller au tableau de bord",
		getStarted: "Commencer",
		learnMore: "En savoir plus",
	},
	pricing: {
		noCardRequired: "Aucune carte de crédit requise pendant la période d'essai",
	},
	testimonials: {
		title: "Confiance et organisation spirituelle",
		subtitle: "Développé avec respect et compréhension des traditions de l'Umbanda",
	},
};
